export const errorText = "Error Loading Conversations";
export const noConverSations = "No Conversations Available";
